import { Steart } from 'app/models/core/steart.model';
import { ZeWidgetDef, ZeWidgetItem } from './vbl.ze.widgets';

export const KmeZeWidgets: ZeWidgetDef[] = [
	new ZeWidgetDef({
		title: 'FRV-Zusatzbewertung plus 1,5-fache Wertung PrivateFinance-/ PrivateMarketsPolice und Fonds',
		key: 'ZE_FondsZusatBewUndProd_KME',
		subTitle: '(Bewertung)',
		stearts: [Steart.KME],
		items: [
			new ZeWidgetItem({
				text: <strong>Summe der Zielerfüllungen im individuellen Arbeitsgebiet 180%</strong>,
				posId: 2235045,
				einheit: '%',
			}),
			new ZeWidgetItem({
				text: <strong>Mindestens in Fonds 85%</strong>,
				posId: 2275621,
			}),
			new ZeWidgetItem({
				text: <strong>Mindestens in FRV-Zusatzbewertung mit PFP/PMP 85%</strong>,
				posId: 2275622,
			}),
		],
	}),

	new ZeWidgetDef({
		title: 'oder Fonds',
		key: 'ZE_Fonds_KME',
		subTitle: '(Bewertung)',
		stearts: [Steart.KME],
		items: [
			new ZeWidgetItem({
				text: <strong>Individuelles Arbeitsgebietsziel 100%</strong>,
				posId: 2235050,
			}),
		],
	}),
];
